import { render, staticRenderFns } from "./grayNumber_area.vue?vue&type=template&id=f9e22362&scoped=true&"
import script from "./grayNumber_area.vue?vue&type=script&lang=js&"
export * from "./grayNumber_area.vue?vue&type=script&lang=js&"
import style0 from "./grayNumber_area.vue?vue&type=style&index=0&id=f9e22362&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9e22362",
  null
  
)

export default component.exports